import { ROUTES } from '@/config/constants';

interface DefaultRouteInput {
  hasClientAccess: boolean;
  isPlatformAdmin: boolean;
}

/**
 * Client access takes priority over platform admin — dual-role users land on
 * the client dashboard by default so day-to-day work is uninterrupted.
 * Platform-only admins (no memberships) route to the platform console.
 */
export function getDefaultAuthenticatedRoute({
  hasClientAccess,
  isPlatformAdmin,
}: DefaultRouteInput): string {
  if (hasClientAccess) {
    return ROUTES.DASHBOARD;
  }

  if (isPlatformAdmin) {
    return ROUTES.PLATFORM_ORGANIZATIONS;
  }

  return ROUTES.UNAUTHORIZED;
}
